import { handleApiResponse } from '../common';
import { SetupConfig } from './types';
import { getApiBaseUrl, API_VERSION } from '../index';

export const setupWizardApi = {
  async getConfig() {
    const response = await fetch(`${getApiBaseUrl()}${API_VERSION}/setup/config`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    const validatedResponse = await handleApiResponse(response);
    const data = await validatedResponse.json();
    return SetupConfig.fromApiResponse(data);
  },

  async saveConfig(config) {
    const formattedConfig = config instanceof SetupConfig ? config.toApiFormat() : new SetupConfig(config).toApiFormat();

    const response = await fetch(`${getApiBaseUrl()}${API_VERSION}/setup/config`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(formattedConfig)
    });

    const validatedResponse = await handleApiResponse(response);
    const data = await validatedResponse.json();
    return SetupConfig.fromApiResponse(data);
  },

  async isConfigured() {
    const response = await fetch(`${getApiBaseUrl()}${API_VERSION}/setup/status`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    const validatedResponse = await handleApiResponse(response);
    const data = await validatedResponse.json();
    return data.configured || false;
  }
};
